import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'
import { EColors } from 'app/constants/colors'

const ToastrWarningIcon = (props: IIconProps) => (
  <BaseIcon width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(.757 .5)" fill="none" fillRule="evenodd">
      <circle fill={EColors.WHITE} cx="16.5" cy="16.5" r="16.5" />
      <g transform="translate(14.823 8.374)">
        <path stroke={EColors.MEDIUM_GREY} strokeWidth="2.43" d="M1.677 10.328V0" />
        <circle fill={EColors.MEDIUM_GREY} cx="1.677" cy="14.576" r="1.677" />
      </g>
    </g>
  </BaseIcon>
)

export default ToastrWarningIcon
